<h2>About Rego</h2>

<p *ngIf="!loggedIn">
  You are not logged in. You are soon taken to login page.
  You can also click <a (click)="auth.login()">log In</a> to continue.
</p>

<div *ngIf="loggedIn">
  <table>
    <thead>
    <th colspan="2">Application state</th>
    </thead>

    <tr>
      <th>Logged in</th>
      <th>{{loggedIn}}</th>
    </tr>

    <tr>
      <th>Is production</th>
      <th>{{isProduction()}}</th>
    </tr>

    <tr>
      <th>Version</th>
      <th>{{version.version}}</th>
    </tr>

    <tr>
      <th>Version date</th>
      <th>{{version.date}}</th>
    </tr>


  </table>
</div>
